import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  updateDoc,
  doc,
  serverTimestamp
} from "firebase/firestore";

import { db } from "../app/Config/firebase";
import { aplicarTenantAtual, consultaTenantAtual } from "../app/Utils/tenant";

/* =========================
   REFERÊNCIA DA COLLECTION
========================= */
const colRef = collection(db, "kpis");

/* =========================
   LISTAR KPIs
========================= */
export async function listarKPIs() {
  const snap = await getDocs(consultaTenantAtual(colRef));

  return snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
}

/* =========================
   CRIAR KPI
========================= */
export async function criarKPI(data) {
  return await addDoc(colRef, aplicarTenantAtual({
    ...data,
    ativo: true,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  }));
}

/* =========================
   OBTER KPI
========================= */
export async function getKPI(id) {
  const snap = await getDoc(doc(db, "kpis", id));
  if (!snap.exists()) throw new Error("KPI não encontrado");

  return {
    id: snap.id,
    ...snap.data(),
  };
}

/* =========================
   ATUALIZAR KPI
========================= */
export async function atualizarKPI(id, data) {
  return await updateDoc(doc(db, "kpis", id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}
